import { Component } from '@angular/core';

@Component({
  standalone: true,
  selector: 'dcc-back-button',
  template: `
    <button class="lx-btn lx-btn-text" (click)="goBack()">
      <i class="lx-icon lx-chevron-lrg-left"></i>
      Back
    </button>
  `,
  styleUrls: ['./back-button.component.scss', '../buttons.scss'],
})
export class BackButtonComponent {
  goBack() {
    window.history.back();
  }
}
